/** AppSync Events channel for one user's notification inbox. */
export const notificationEventChannel = (userId: string): string => `notifications/${userId}`;

/** Shared channel pinged when a broadcast notification is created. */
export const NOTIFICATION_BROADCAST_EVENT_CHANNEL = "notifications/broadcast";
